export const clearLocalStorage = () => localStorage.clear();
export const getAuthToken = () => localStorage.getItem("token");
export const getUserId = () => localStorage.getItem("userId");
export const setToken = token => localStorage.setItem("token", token);
export const setRole = role => localStorage.setItem("role", role);
export const setUserId = userId => localStorage.setItem("userId", userId);
